/**
 * MarketingLayout.tsx
 *
 * Layout for Marketing pages. Navigation is handled by the main sidebar;
 * this layer enforces the per-account Marketing module access configured in
 * Prospera-Corp-App's Module Settings: module off → out of /marketing
 * entirely; a disabled section slug → back to the marketing dashboard.
 */
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useModuleAccess } from '@/hooks/useAccountModules';

export default function MarketingLayout() {
  const { enabled, disabledSections, isLoading } = useModuleAccess('marketing');
  const location = useLocation();

  // Fail-open while loading — never flash staff out of a page they may have.
  if (!isLoading) {
    if (!enabled) {
      return <Navigate to="/" replace />;
    }
    // First path segment after /marketing is the section slug
    // (e.g. /marketing/push-campaigns/123 → "push-campaigns").
    const section = location.pathname.replace(/^\/marketing\/?/, '').split('/')[0];
    if (section && disabledSections.includes(section)) {
      return <Navigate to="/marketing" replace />;
    }
  }

  return <Outlet />;
}
